import { SummaryDataChanged } from "event-definitions"
import { noChange } from "lib/@hooks/useRefresh"
import { Grid, InputLabel } from "@mui/material"
import { SummaryClassification, SummarySkilling, SummaryTiming } from "slot-definitions"
import { CollapseItem } from "routes/schedule/plugins/summary-tab/collapse-item"

export function Summary() {
    SummaryDataChanged.useRefresh(noChange)
    return (
        <Grid className="summary-schedule" data-cy="schedule-summary" container spacing={1}>
            <Grid item>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <InputLabel data-cy="schedule-summary-classification" shrink>
                            Classification
                        </InputLabel>
                    </Grid>
                    <SummaryClassification.Slot Container={<CollapseItem />} />
                </Grid>
            </Grid>
            <Grid item>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <InputLabel data-cy="schedule-summary-timing" shrink>
                            Timing
                        </InputLabel>
                    </Grid>
                    <SummaryTiming.Slot Container={<CollapseItem />} />
                </Grid>
            </Grid>
            <Grid item>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <InputLabel data-cy="schedule-summary-skill" shrink>
                            Skill
                        </InputLabel>
                    </Grid>
                    <SummarySkilling.Slot Container={<CollapseItem />} />
                </Grid>
            </Grid>
        </Grid>
    )
}
